import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LegalFooter from '@/components/LegalFooter';

export default function Terms() {
    return (
        <div className="min-h-screen bg-background flex flex-col" data-testid="terms-page">
            <div className="pointer-events-none absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-sage/30 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-40 -right-40 w-[460px] h-[460px] rounded-full bg-dusty/40 blur-3xl" />

            <header className="relative z-10 max-w-3xl mx-auto w-full px-6 py-8">
                <Link to="/" className="inline-flex items-center gap-2 text-forest-soft hover:text-forest text-sm">
                    <ArrowLeft size={16} /> Back home
                </Link>
            </header>

            <main className="relative z-10 max-w-3xl mx-auto w-full px-6 pb-10 prose prose-stone">
                <h1 className="font-serif text-4xl text-forest mb-3">Terms of Use</h1>
                <p className="text-sm text-forest-soft">Last updated: February 2026</p>

                <h2 className="font-serif text-2xl text-forest mt-8">1. Nature of the service</h2>
                <p className="text-forest-soft leading-relaxed">
                    Quiet Mind is a meditation companion. It offers curated meditations, ambient music, and AI-crafted reflections. The content is intended for general wellbeing and self-reflection. It is not a substitute for professional medical, psychological, or legal advice.
                </p>

                <h2 className="font-serif text-2xl text-forest mt-8">2. Your account</h2>
                <p className="text-forest-soft leading-relaxed">
                    You are responsible for keeping your account credentials and recovery code secure. You may close your account at any time from your Profile; closed accounts enter a 30-day soft-deletion window and are permanently purged after that.
                </p>

                <h2 className="font-serif text-2xl text-forest mt-8">3. Affiliate links</h2>
                <p className="text-forest-soft leading-relaxed">
                    If you purchase anything through a link in this tool, you should assume that we have an affiliate relationship with the company providing the product or service and may be compensated. We recommend that you do your own independent research before purchasing anything.
                </p>

                <h2 className="font-serif text-2xl text-forest mt-8">4. Disclaimer</h2>
                <p className="text-forest-soft leading-relaxed">
                    By using Quiet Mind, you agree that the content here is an expression of opinions and not professional, medical, or legal advice. You are solely responsible for the use of any content and you hold Quiet Mind, Dr Brandt Gibson, LLC, Dr Brandt R Gibson, and all members and affiliates harmless in any event or claim.
                </p>

                <h2 className="font-serif text-2xl text-forest mt-8">5. Refunds & gifts</h2>
                <p className="text-forest-soft leading-relaxed">
                    Premium subscriptions purchased in-app or through a ClickFunnels funnel are non-refundable except where required by law. Gifted premium periods are credited to the recipient&rsquo;s account upon redemption and are non-transferable.
                </p>

                <h2 className="font-serif text-2xl text-forest mt-8">6. Contact</h2>
                <p className="text-forest-soft leading-relaxed">
                    Questions? Reach us at <a href="mailto:support@drbrandtgibson.com" className="underline">support@drbrandtgibson.com</a>.
                </p>
            </main>

            <LegalFooter />
        </div>
    );
}
